var chunkMapping = {
	"0": [
		4649
	],
	"3": [
		4056,
		4350
	],
	"79": [
		5082
	],
	"164": [
		5167
	],
	"165": [
		5168
	],
	"168": [
		5171
	],
	"169": [
		5172
	],
	"170": [
		5173
	],
	"171": [
		5174
	],
	"172": [
		5175
	],
	"173": [
		5176
	],
	"174": [
		5177
	],
	"175": [
		5178
	],
	"176": [
		5179
	],
	"177": [
		5180
	],
	"178": [
		5181
	],
	"179": [
		5182
	],
	"180": [
		5183
	],
	"181": [
		5184
	],
	"182": [
		5185
	],
	"183": [
		5186
	],
	"184": [
		5187
	],
	"185": [
		5188
	],
	"186": [
		5189
	],
	"187": [
		5190
	]
};
var idToExternalAndNameMapping = {
	"4056": [
		"default",
		"./nuorder-components",
		3671
	],
	"4350": [
		"default",
		"./helios-components",
		3671
	],
	"4649": [
		"default",
		"./Containers",
		3581
	],
	"5082": [
		"default",
		"./OrderlessInvoices",
		3581
	],
	"5167": [
		"default",
		"./AsyncEventTracker",
		3581
	],
	"5168": [
		"default",
		"./HostWrapper",
		3581
	],
	"5171": [
		"default",
		"./CheckoutV3",
		3581
	],
	"5172": [
		"default",
		"./CheckoutConfirmation",
		3581
	],
	"5173": [
		"default",
		"./ContactCreditCards",
		3581
	],
	"5174": [
		"default",
		"./AuditDialog",
		3581
	],
	"5175": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3581
	],
	"5176": [
		"default",
		"./InvoiceDialog",
		3581
	],
	"5177": [
		"default",
		"./PaymentDueModal",
		3581
	],
	"5178": [
		"default",
		"./PaymentModal",
		3581
	],
	"5179": [
		"default",
		"./PaymentHistory",
		3581
	],
	"5180": [
		"default",
		"./PaymentConfigurations",
		3581
	],
	"5181": [
		"default",
		"./PaymentPreferences",
		3581
	],
	"5182": [
		"default",
		"./ManagePaymentProcessing",
		3581
	],
	"5183": [
		"default",
		"./MobilePaymentsWrapper",
		3581
	],
	"5184": [
		"default",
		"./PayPage",
		3581
	],
	"5185": [
		"default",
		"./Challenge",
		3581
	],
	"5186": [
		"default",
		"./ManagePaymentMethods",
		3581
	],
	"5187": [
		"default",
		"./LightspeedReports",
		3581
	],
	"5188": [
		"default",
		"./ActivateLightspeedPayments",
		3581
	],
	"5189": [
		"default",
		"./MarketingLandingPage",
		3581
	],
	"5190": [
		"default",
		"./ShippingPromotionsListContainer",
		3581
	]
};
var idToRemoteMap = {
	"4056": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3671
		}
	],
	"4350": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3671
		}
	],
	"4649": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5082": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5167": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5168": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5171": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5172": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5173": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5174": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5175": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5176": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}